import { render } from "./eventListTable.vue?vue&type=template&id=c6e886c6"
import script from "./eventListTable.vue?vue&type=script&lang=js"
export * from "./eventListTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__